<!-- eslint-disable @angular-eslint/template/no-any -->
<ul class="emails">
  @for (recipient of solicitationService.recipients; track recipient) {
    <li>
      @for (email of recipient.emails; track email) {
        <span class="chip" data-test-id="chip-list-item">
          <span data-test-id="chip-list-item-text">
            {{ email.address }}
          </span>
          @if ($any(recipient).type === 'unverified') {
            <span class="unverified-indicator">?</span>
          }
          <mat-icon class="closebtn" data-test-id="chip-list-item-remove" (click)="removeFromList(recipient)">
            close
          </mat-icon>
        </span>
      }
    </li>
  }
</ul>
